import { UserBadge } from "../common/UserBadge"
import VerifiedUserIcon from '@mui/icons-material/VerifiedUser';
import DoneAllIcon from '@mui/icons-material/DoneAll';
import DoneIcon from '@mui/icons-material/Done';
import { format } from 'date-fns';
import formatTimeAgo from "../hooks/formatTimeAgo";
import { useAppSelector } from "../../store/hooks";
import formatLimitedText from "../hooks/formatLimitedText";
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import ArchiveIcon from '@mui/icons-material/Archive';
import { useEffect, useState } from "react";
import { useTimeAgo } from "../../utils/hooks/useTimeAgo";

export interface ChatListCardProps {
    data: {
        rentalTitle: string;
        name: string;
        profileImg: string;
        lastMessage: string;
        timeAgo: Date;
        lastMessageUserId?: number;
        userVerified?: boolean; // Optional field
        rentalIsActive: boolean;
        chatId: number;
        lastMessageSeen: boolean;
        newMessage?: boolean;
    };

    onClick: () => void;
    selectedChatId?: number;
}

export const ChatListCard: React.FC<ChatListCardProps> = ({ data, onClick, selectedChatId }) => {
    const [lastMessageNotSeen, setLastMessageNotSeen] = useState(false);
    const {timeAgo, setTimeAgo} = useTimeAgo(data.timeAgo)

    const user = useAppSelector(state => state.auth.user);
    
    useEffect(() => {
        if (user?.id) {
            setLastMessageNotSeen(data.lastMessageUserId != user.id && data.lastMessageSeen == false)
        }
    }, [user, data.lastMessageUserId, data.lastMessageSeen])

    useEffect(() => {
        setTimeAgo(formatTimeAgo(data.timeAgo))
    }, [data.timeAgo])
    

    return (
        <div className="flex flex-col w-full gap-1">

            <div>
                <h4 className="text-sm text-primary">• {data.rentalTitle}</h4>
            </div>
            <div onClick={onClick} className={`${selectedChatId === data.chatId ? "bg-primary_light" : "bg-white"} group relative flex flex-row gap-2 w-full shadow-main rounded-xl p-2 cursor-pointer hover:bg-primary_light transition-all duration-300`}>
                <div className="flex gap-1 opacity-0 pointer-events-none group-hover:opacity-100 group-hover:pointer-events-auto justify-center flex-col absolute h-full right-full top-0 pr-2 w-[32px]">
                    <div onClick={() => {}} className="flex justify-center items-center relative group/icon text-gray-300"><DeleteOutlineIcon />
                        <div className="z-[-1] group-hover/icon:h-[30px] group-hover/icon:w-[30px] absolute left-1/2 top-1/2 translate-x-[-50%] translate-y-[-50%] bg-primary_light rounded-full h-0 w-0 transition-all duration-200"></div>

                    </div>
                    <div onClick={() => {}} className="flex justify-center items-center relative group/icon text-gray-300"><ArchiveIcon />
                        <div className="z-[-1] group-hover/icon:h-[30px] group-hover/icon:w-[30px] absolute left-1/2 top-1/2 translate-x-[-50%] translate-y-[-50%] bg-primary_light rounded-full h-0 w-0 transition-all duration-200"></div>
                    </div>
                </div>
                <div>
                    <UserBadge size={"small"} profileIconUrl={data.profileImg} profileId={1} />
                </div>
                <div className="flex-grow">
                    <div className="flex flex-row flex-grow justify-between gap-2">
                        <div className="flex flex-row items-center">
                            <div className="flex flex-row items-center">
                                <h4>{formatLimitedText(15, data.name)}</h4>
                                {!!data.userVerified && <VerifiedUserIcon className="text-primary max-h-[16px]" />}
                            </div>
                        </div>
                        <div className="flex flex-row gap-2">
                            {
                                (data.newMessage || lastMessageNotSeen) &&
                                <div className="rounded-lg bg-primary p-1 text-white text-[12px] h-fit">
                                    Uus
                                </div>
                            }
                            {data.rentalIsActive &&
                                <DoneAllIcon style={{ color: "green" }} />
                            }
                        </div>
                    </div>

                    <div className="flex flex-col">
                        {
                            data.newMessage ?
                            <div>
                                <div className="font-bold opacity-100 text-sm">Uus sõnum kasutajalt</div>
                            </div>
                            :
                            <div className="flex flex-row gap-1">
                                {data.lastMessageUserId === user?.id && <div className="opacity-80 text-sm font-semibold">Sina:</div>}
                                <div className={`${lastMessageNotSeen ? "font-bold opacity-100" : "opacity-80"} text-sm`}>{formatLimitedText(18, data.lastMessage) }</div>
                                <div className="font-semibold text-sm">•</div>
                                <div className="font-semibold text-sm">{timeAgo}</div>
                            </div>
                        }
                    </div>
                </div>

            </div>

        </div>
    )
}

